import './Box.scss';

type BoxProps = {
  children: React.JSX.Element;
  bgColor: 'aqua' | 'lilac' | 'red' | 'white' | 'aqua-dark';
  classes?: string;
};

function Box({ children, bgColor, classes }: BoxProps): React.JSX.Element {
  return <div className={`box ${bgColor} ${classes}`}>{children}</div>;
}

export default Box;
